<template>
    <div class="stripe-field-wrapper">
        <div class="stripe-field-container select-container" v-bind:class="fieldClass">
            <select :required="required" @change="handleInput" ref="select" class="stripe-field">
                <option value="">Country</option>
                <option
                    v-for="country in countries"
                    v-bind:value="country.country_id"
                    v-bind:selected="value == country.country_id"
                >
                    {{ country.country_name }}
                </option>
            </select>
        </div>
        <div class="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: 'checkout-country-select',
    props: {
        'value': {
            type: String
        },
        'required': {
            type: Boolean,
            default: true
        },
        'countries': {
            type: Array
        }
    },
    data() {
        return {
            error: ''
        }
    },
    methods: {
        validate () {
            this.error = "";
            var value = this.$refs.select.value;
            if(!value && this.required) {
                this.error = "This is a required field";
            }
        },
        handleInput () {
            this.validate();
            var value = this.$refs.select.value;
            this.$emit('input', value);
        }
    },
    computed: {
        fieldClass: function(component) {
            return {
                'validation-failed': this.error != ''
            }
        }
    }
};
</script>